export default "__VITE_ASSET__DhwAjgaz__"